class Slider {
  constructor(callbacks, opts) {
    this.bindControls = this.bindControls.bind(this)
    this.value = this.value.bind(this)
    this.setDragger = this.setDragger.bind(this)
    if (callbacks == null) {
      callbacks = {}
    }
    this.callbacks = callbacks
    if (opts == null) {
      opts = {}
    }
    this.dragger = $(opts.identifier || '.js-dragger')
    this.track = this.dragger.parent()
    this.container = this.track.parent()
    this.percentage = opts.percentage || 50
    this.bindControls()
    this.setDragger()
  }

  bindControls() {
    return this.dragger.on('mousedown', mousedownEvent => {
      mousedownEvent.preventDefault()
      $('body').css({cursor: 'pointer'})
      if (this.callbacks.mouseDown != null) {
        this.callbacks.mouseDown()
      }

      $(document).on('mousemove.dragger', event => {
        event.preventDefault()

        const min = 0
        const max = this.track.width() - this.dragger.width()

        let left = event.clientX - this.track.offset().left
        if (left < min) {
          left = min
        }
        if (left > max) {
          left = max
        }
        this.dragger.css({left})

        this.percentage = (left / max) * 100
        window.debug(`Slider at ${this.percentage}%`)
        if (this.callbacks.slide != null) {
          return this.callbacks.slide(this.percentage)
        }
      })

      return $(document).on('mouseup.dragger', () => {
        $(document).off('.dragger')
        $('body').css({cursor: 'auto'})
        if (this.callbacks.mouseUp != null) {
          return this.callbacks.mouseUp()
        }
      })
    })
  }

  value() {
    return this.percentage
  }

  setDragger() {
    const max = this.track.width() - this.dragger.width()
    const left = (this.percentage / 100) * max
    return this.dragger.css({left})
  }

  show() {
    this.container.show()
    return this.setDragger()
  }

  hide() {
    return this.container.hide()
  }
}

export default Slider
